<!-- Modal Overlay -->
<div class="modal-overlay" (click)="cancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h3 class="modal-title">Request Transfer</h3>
      <button class="modal-close" (click)="cancel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <form [formGroup]="transferForm" (ngSubmit)="submit()" class="modal-body">
      <!-- Source Location -->
      <div class="form-group">
        <label for="sourceLocationId" class="form-label">Source Location</label>
        <select id="sourceLocationId" formControlName="sourceLocationId" class="form-select">
          <option [ngValue]="null">Select source location...</option>
          <option *ngFor="let loc of locations" [ngValue]="loc.locationId">
            {{ loc.locationName }}
          </option>
        </select>
        <div *ngIf="sourceLocationId?.invalid && sourceLocationId?.touched" class="form-error">
          Source location is required
        </div>
      </div>

      <!-- Target Location -->
      <div class="form-group">
        <label for="targetLocationId" class="form-label">Target Location</label>
        <select id="targetLocationId" formControlName="targetLocationId" class="form-select">
          <option [ngValue]="null">Select target location...</option>
          <option *ngFor="let loc of locations" [ngValue]="loc.locationId">
            {{ loc.locationName }}
          </option>
        </select>
        <div *ngIf="targetLocationId?.invalid && targetLocationId?.touched" class="form-error">
          Target location is required
        </div>
        <div *ngIf="transferForm.errors?.['sameLocation'] && targetLocationId?.touched" class="form-error">
          Source and target locations must be different
        </div>
      </div>

      <!-- Mat Type -->
      <div class="form-group">
        <label class="form-label">Mat Type</label>
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio" formControlName="matType" value="Wood">
            <span>Wood</span>
          </label>
          <label class="radio-label">
            <input type="radio" formControlName="matType" value="Poly">
            <span>Poly</span>
          </label>
        </div>
      </div>

      <!-- Quantity -->
      <div class="form-group">
        <label for="quantity" class="form-label">
          Quantity
          <span *ngIf="getAvailableQuantity() > 0" class="available-info">
            ({{ getAvailableQuantity() }} available)
          </span>
        </label>
        <input 
          type="number" 
          id="quantity" 
          formControlName="quantity" 
          class="form-input"
          placeholder="Enter quantity..."
          min="1"
          [max]="getAvailableQuantity()"
        >
        <div *ngIf="quantity?.invalid && quantity?.touched" class="form-error">
          <span *ngIf="quantity?.errors?.['required']">Quantity is required</span>
          <span *ngIf="quantity?.errors?.['min']">Quantity must be greater than 0</span>
        </div>
      </div>

      <!-- Info Box -->
      <div class="info-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <span>This will move inventory from Source-Available to Source-In_Transit and create a pending transfer for the target location.</span>
      </div>

      <!-- Modal Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="transferForm.invalid">
          Request Transfer
        </button>
      </div>
    </form>
  </div>
</div>
